var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar ${_vm.state.question}`
                                  : "Novo Cupom"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text: "Lista de Cupons",
                              href: "#/coupons"
                            },
                            {
                              text: "Cadastro de Cupons",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Nome/Identificador" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder:
                                        "Informe o nome/Identificador",
                                      state: _vm.isOk("name")
                                    },
                                    model: {
                                      value: _vm.state.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "name", $$v)
                                      },
                                      expression: "state.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("name")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Descrição",
                                    "label-for": "input-2"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      placeholder: "Informe a descrição",
                                      rows: "3",
                                      "max-rows": "6",
                                      state: _vm.isOk("description")
                                    },
                                    model: {
                                      value: _vm.state.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "description", $$v)
                                      },
                                      expression: "state.description"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("description")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Data Início",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("start"),
                                      id: "example-datepicker-beg",
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.start,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "start", $$v)
                                      },
                                      expression: "state.start"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("start")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("start")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Data Fim",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("end"),
                                      id: "example-datepicker-end",
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.end,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "end", $$v)
                                      },
                                      expression: "state.end"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("end")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("end")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Perfil",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.state.profile,
                                          expression: "state.profile"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.state,
                                            "profile",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione o perfil")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "consumer" } },
                                        [_vm._v("Consumidor")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "trader" } },
                                        [_vm._v("Comercializador")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "investor" } },
                                        [_vm._v("Investidor")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    class: {
                                      "is-invalid": !_vm.isOk("profile")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isOk("profile") === false
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(_vm._s(_vm.getError("profile")))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.state.profile
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-3",
                                        label: "Tipo",
                                        "label-for": "input-group-3"
                                      }
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.state.type,
                                              expression: "state.type"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.state,
                                                "type",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "", value: "" }
                                            },
                                            [_vm._v("Selecione o tipo")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.typeOptions, function(
                                            type,
                                            index
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                key: `${index}-${type.value}`,
                                                domProps: { value: type.value }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(type.text) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        class: {
                                          "is-invalid": !_vm.isOk("type")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.isOk("type") === false
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v(_vm._s(_vm.getError("type")))
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Status",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.state.status,
                                          expression: "state.status"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.state,
                                            "status",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione o status")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "ACTIVE" } },
                                        [_vm._v("Ativo")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "INACTIVE" } },
                                        [_vm._v("Inativo")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    class: { "is-invalid": !_vm.isOk("status") }
                                  }),
                                  _vm._v(" "),
                                  _vm.isOk("status") === false
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(_vm._s(_vm.getError("status")))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Limite",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "text-right",
                                    attrs: {
                                      placeholder:
                                        "Informe o limite de usos do cupom",
                                      state: _vm.isOk("value")
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.calc()
                                      },
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.limit,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "limit", $$v)
                                      },
                                      expression: "state.limit"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("limit")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.save(),
                                  label: "Salvar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }